// extracted by mini-css-extract-plugin
export default {"wrapper":"EditHolidayMembersForm_wrapper__u-5Gv","membersWrapper":"EditHolidayMembersForm_membersWrapper__DPAXC","submitWrapper":"EditHolidayMembersForm_submitWrapper__xF3sB"};